import { useMemo, useRef, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchYearSingleForm } from "src/components/common/form/search/SearchYearSingleForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { showWarning } from "src/utils/toast/toastUtil";
import { useHRM3130_R01Store } from "./Store_HRM3130_R01";
import { HRM3130_R01_FAMILY_COUNT_LIST, formatHRM3130_R01Amount } from "./Util_HRM3130_R01";
/** 미리보기·업로드 동작을 받는 검색 영역 속성이다. */
interface Props {
    onIncomeTaxSearch: () => void; // 입력 조건의 세액 계산
    onUploadFile: (file: File) => void; // 선택 파일 파싱·확인
}
/** 적용년도·월 과세급여·가족수와 업로드 버튼을 반환한다. */
export const HRM3130_R01SearchSection = ({ onIncomeTaxSearch, onUploadFile }: Props) => {
    const state = useHRM3130_R01Store(); // 검색 조건 구독
    const filter = state.HRM3130_R01Filter; // 현재 입력
    const [visible, setVisible] = useState(false); // true이면 연도 선택기 표시
    const [position, setPosition] = useState({ top: 0, left: 0 }); // 연도 선택기 위치
    const fileInputRef = useRef<HTMLInputElement>(null); // 업로드 버튼과 같은 컴포넌트의 숨긴 입력 참조
    const yearValue = useMemo(() => filter.applyYear ? new Date(Number(filter.applyYear), 0, 1) : undefined, [filter.applyYear]); // 연도 문자열 변경 때 Date 생성
    return <SearchSectionForm>
        {/* 연도는 Date로 선택하고 YYYY 문자열로 저장한다. 변경 시 기존 계산 결과를 지운다. */}
        <SearchYearSingleForm label="적용년도" visible={visible} setVisible={setVisible} value={yearValue}
            pickerPosition={position} setPickerPosition={setPosition}
            onChange={date => { if (date) { state.setHRM3130_R01Filter({ applyYear: String(date.getFullYear()) }); state.setHRM3130_R01IncomeTax(undefined); } }} />
        {/* 숫자만 보관하고 천 단위로 표시한다. Enter가 미리보기를 실행한다. */}
        <SearchInputForm label="월 과세급여" value={filter.taxableAmt ? formatHRM3130_R01Amount(Number(filter.taxableAmt)) : ''}
            onChange={event => {
                // 숫자가 아닌 문자를 모두 제거한다.
                const value = event.target.value.replace(/[^\d]/g, '');
                state.setHRM3130_R01Filter({ taxableAmt: value });
                state.setHRM3130_R01IncomeTax(undefined);
            }} initValue={() => { state.setHRM3130_R01Filter({ taxableAmt: '' }); state.setHRM3130_R01IncomeTax(undefined); }}
            onKeyDown={event => { if (event.key === 'Enter') onIncomeTaxSearch(); }} />
        {/* 화면 고정 가족수 1~11을 선택하며 전체 선택은 표시하지 않는다. */}
        <SearchDropDownForm label="공제대상가족" value={filter.familyCount} optionList={HRM3130_R01_FAMILY_COUNT_LIST} initLabelLess
            onChangeValue={value => { state.setHRM3130_R01Filter({ familyCount: value }); onIncomeTaxSearch(); }} />
        {/* HRM3050 검색 영역 전용 버튼과 같은 스타일로 파일 선택을 연다. */}
        <button type="button" className="flex-shrink-0 bg-white hover:bg-gray-100 ml-20 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
            onClick={() => { if (!state.HRM3130_R01PastFilter.applyYear) { showWarning('먼저 조회하세요.'); return; } fileInputRef.current?.click(); }}>국세청 엑셀 업로드</button>
        {/* 같은 파일을 재선택할 수 있도록 선택 직후 입력값을 비운다. */}
        <input ref={fileInputRef} type="file" accept=".xlsx" className="hidden" onChange={event => {
            const file = event.target.files?.[0]; // 첫 선택 파일
            event.target.value = '';
            if (file) onUploadFile(file);
        }} />
    </SearchSectionForm>;
};
